{
    "(save {highestYearlyDiscount}%)": "",
    "{amount} days free": "{amount} dae gratis",
    "{amount} off": "{amount} afslag",
    "{amount} off for first {number} months.": "{amount} afslag vir die eerste {number} maande.",
    "{amount} off for first {period}.": "{amount} afslag vir die eerste {period}.",
    "{amount} off forever.": "{amount} afslag vir altyd.",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "{buyerName} has gifted you a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "{buyerName} has gifted you a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "{discount}% discount": "{discount}% afslag",
    "{duration} membership": "",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "{memberEmail} sal nie meer die {newsletterName} nuusbrief ontvang nie.",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "{memberEmail} sal nie meer e-posse ontvang wanneer iemand op u kommentaar reageer nie.",
    "{memberEmail} will no longer receive this newsletter.": "{memberEmail} sal nie meer hierdie nuusbrief ontvang nie.",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} month": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "{trialDays} dae gratis",
    "{years} years": "",
    "+1 (123) 456-7890": "",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "Rekening",
    "Account details updated successfully": "",
    "Account settings": "Rekening instellings",
    "Add a personal note": "",
    "Add a short note to go with your gift": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "Na afloop van die gratis proeftydperk sal u die vasgestelde pry vir die vlak wat u gekies het, betaal. U kan altyd voor die tyd kanselleer.",
    "Already a member?": "Is u reeds 'n lid?",
    "An error occurred": "",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "'n Onverwagte fout het voorgekom. Probeer asseblief weer of <a>kontak kliëntediens</a> as die fout voortduur.",
    "Back": "Terug",
    "Back to Log in": "Terug na aanmelding",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "Swart Vrydag",
    "Bluesky": "",
    "Buy": "",
    "Buying for someone else?": "",
    "Cancel anytime.": "Kanselleer enige tyd.",
    "Cancel subscription": "Kanselleer inskrywing",
    "Canceled": "",
    "Cancellation reason": "Kansellasie rede",
    "Change": "Verander",
    "Change plan": "",
    "Check spam & promotions folders": "Kyk in spam & promosie vouers",
    "Check with your mail provider": "Kyk by u e-posverskaffer",
    "Check your inbox to verify email update": "",
    "Choose": "Kies",
    "Choose a date from today onwards": "",
    "Choose a date within the next year": "",
    "Choose a delivery date": "",
    "Choose a different plan": "Kies 'n ander plan",
    "Choose a plan": "",
    "Choose a tier": "",
    "Choose your newsletters": "Kies u nuusbriefs",
    "Click here to retry": "Kliek hier om weer te probeer",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "Sluit",
    "Code": "",
    "Comment preferences updated.": "",
    "Comments": "Kommentaar",
    "Complimentary": "Komplimentêr",
    "Confirm": "Bevestig",
    "Confirm cancellation": "Bevestig kansellasie",
    "Confirm subscription": "Bevestig inskrywing",
    "Contact support": "Kontak kliëntediens",
    "Continue": "Gaan voort",
    "Continue subscription": "Gaan voort met inskrywing",
    "Continue to delivery details": "",
    "Continue to payment": "",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "",
    "Could not sign in. Login link expired.": "Kon nie aanmeld nie. Aanmeldskakel het verval.",
    "Could not update email! Invalid link.": "Kon nie e-pos opdateer nie! Ongeldige skakel.",
    "Create a new contact": "Skep 'n nuwe kontak",
    "Current plan": "Huidige plan",
    "Delete account": "Verwyder rekening",
    "Delivery date": "",
    "Delivery method": "",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "Het dit nie bedoel om te doen nie? Bestuur jou voorkeure <button>hier</button>.",
    "Don't have an account?": "Het u nie 'n rekening nie?",
    "Edit": "Wysig",
    "Email": "E-pos",
    "Email confirmation link expired.": "",
    "Email it to them": "",
    "Email newsletter": "Epos nuusbrief",
    "Email newsletter settings updated": "",
    "Email preferences": "E-pos instellings",
    "Email preferences updated.": "",
    "Emails": "E-posse",
    "Emails disabled": "E-posse afgeskakel",
    "Ends {offerEndDate}": "Eindig {offerEndDate}",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "",
    "Enter the recipient's email address": "",
    "Enter your email address": "",
    "Enter your name": "",
    "Error": "Fout",
    "Expires {expiryDate}": "Verval {expiryDate}",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "",
    "Failed to log in, please try again": "",
    "Failed to log out, please try again": "",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": "",
    "Failed to send magic link email": "",
    "Failed to send verification email": "",
    "Failed to sign up, please try again": "",
    "Failed to update account data": "",
    "Failed to update account details": "",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "",
    "Failed to update subscription, please try again": "",
    "Failed to verify code, please try again": "",
    "For a friend or colleague": "",
    "Forever": "Verewig",
    "Free Trial – Ends {trialEnd}": "Gratis proeftydperk – Eindig {trialEnd}",
    "From": "",
    "Get help": "Kry hulp",
    "Get in touch for help": "Kontak vir hulp",
    "Get notified when someone replies to your comment": "Ontvang 'n kennisgewing wanneer iemand op u kommentaar reageer",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift duration": "",
    "Gift link copied to clipboard": "",
    "Gift membership": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "Gee terugvoering oor hierdie pos",
    "Help! I'm not receiving emails": "Help! Ek ontvang nie e-posse nie",
    "Here are a few other sites you may enjoy.": "Hier is 'n paar ander webwerwe wat jy dalk sal geniet.",
    "Hi {recipientName},": "",
    "Hide details": "",
    "How would you like to share this gift?": "",
    "I'll share it myself": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "As 'n nuusbrief as spam geïdentifiseer word, word e-posse outomaties vir daardie adres afgeskakel om seker te maak dat u geen ongewenste boodskappe meer ontvang nie.",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "As die spam klag per ongeluk was, of as u weer e-posse wil begin ontvang, kan u weer inskryf vir e-posse deur op die knoppie op die vorige skerm te klik.",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "As u nou kanselleer, sal u toegang hê tot {periodEnd}.",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "As u 'n korporatiewe of regerings e-posrekening het, kontak u IT-afdeling en vra hulle om e-posse van {senderEmail} te ontvang",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "'n Aanmeldskakel is na u epos gestuur. As dit nie binne 3 minute aankom nie, moet u asseblief u spam-vouer nagaan.",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "As u weer e-posse wil begin ontvang, is die beste volgende stap om u e-posadres op rekord te kontroleer vir enige probleme en dan weer in te skryf op die vorige skerm.",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "As u nie die e-pos nuusbrief ontvang wat u op ingeteken het nie, is hier 'n paar goed om te kontroleer.",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "As u al hierdie kontroles voltooi het en u steeds nie e-posse ontvang nie, kan u hulp kry deur {supportAddress} te kontak.",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "In die geval dat 'n permanente fout ontvang word wanneer 'n nuusbrief gestuur word, sal e-posse op die rekening afgeskakel word.",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "In u e-pos program, voeg {senderEmail} by u kontaklys. Dit dui aan u e-posverskaffer aan dat e-posse wat van hierdie adres gestuur word, vertrou moet word.",
    "Invalid email address": "",
    "Invalid verification code": "",
    "Jamie Larson": "",
    "jamie@example.com": "",
    "Less like this": "Minder soos hierdie",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "Maak seker dat e-posse nie per ongeluk in die Spam of Promosies vouers van u posbus beland nie. As dit wel is, kliek op \"Mark as not spam\" en/of \"Move to inbox\".",
    "Manage": "Bestuur",
    "Maybe later": "Dalk later",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "",
    "Memberships unavailable, contact the owner for access.": "Lidmaatskap nie beskikbaar nie, kontak die eienaar vir toegang.",
    "month": "",
    "Monthly": "Maandeliks",
    "More like this": "Meer soos hierdie",
    "More options": "",
    "Name": "Naam",
    "Need more help? Contact support": "Benodig meer hulp? Kontak kliëntediens",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "Nuusbriewe kan op u rekening afgeskakel word vir twee redes: 'n Vorige e-pos is as spam gemerk, of 'n poging om 'n e-pos te stuur het tot 'n permanente fout gelei (bounce).",
    "No member exists with this e-mail address.": "",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "Ontvang u nie e-posse nie?",
    "Now": "",
    "Now check your email!": "Kyk nou u e-pos!",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "As u weer ingeskryf is, en u sien steeds nie e-posse in u posbus nie, kontroleer u spam vouer. Sommige posbusverskaffers hou 'n rekord van vorige spam klagtes en sal steeds e-posse merk. As dit gebeur, merk die nuutste nuusbrief as 'Not spam' om dit terug te skuif na u primêre posbus.",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Optional message": "",
    "Permanent failure (bounce)": "Permanente fout (bounce)",
    "Phone number": "",
    "Plan": "Plan",
    "Plan checkout was cancelled.": "Plan afreken is gekanselleer.",
    "Plan upgrade was cancelled.": "Plan opgradering is gekanselleer.",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "Kontak {supportAddress} om jou komplimentêre intekening aan te pas.",
    "Please enter {fieldName}": "",
    "Please fill in required fields": "Vul asseblief die verpligte velde in",
    "Podcasts": "",
    "Re-enable emails": "Her-aktiveer eposse",
    "Recipient's email": "",
    "Recipient's name": "",
    "Recommendations": "Aanbevelings",
    "Redeem your gift": "",
    "Redeem your membership": "",
    "Redeeming...": "",
    "Renews at {price}.": "Hernu teen {price}.",
    "Resume subscription": "",
    "Retry": "Probeer weer",
    "Save": "Stoor",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "Stuur aanmeldskakel...",
    "Sending...": "Stuur...",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Share it yourself": "",
    "Show all": "Wys almal",
    "Sign in": "Meld aan",
    "Sign out": "Teken uit",
    "Sign up": "Registreer",
    "Signup error: Invalid link": "Aanmelding fout: Ongeldige skakel",
    "Signups from this email domain are currently restricted.": "",
    "Something went wrong, please try again later.": "",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "",
    "Sorry, that didn’t work.": "Jammer, dit het nie gewerk nie.",
    "Spam complaints": "Spam klagtes",
    "Start {amount}-day free trial": "Begin {amount}-dag gratis proeftydperk",
    "Starting {startDate}": "Begin {startDate}",
    "Starting today": "Begin vandag",
    "Submit feedback": "Stuur terugvoering",
    "Subscribe": "Teken in",
    "Subscribed": "Ingeteken",
    "Subscription plan updated successfully": "",
    "Success": "Sukses",
    "Success! Check your email for magic link to sign-in.": "Sukses! Kyk in jou e-pos vir 'n magiese skakel om aan te meld.",
    "Success! Your account is fully activated, you now have access to all content.": "Sukses! U rekening is ten volle geaktiveer, u het nou toegang tot alle inhoud.",
    "Success! Your email is updated.": "Sukses! U e-pos is opgedateer.",
    "Successfully unsubscribed": "Suksesvol afgemeld",
    "Taylor Reid": "",
    "taylor@example.com": "",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "Dankie dat jy ingeteken het. Voordat jy begin lees, hieronder is 'n paar ander webwerwe wat jy dalk sal geniet.",
    "Thank you for your support": "",
    "Thank you for your support!": "",
    "Thanks for the feedback!": "Dankie vir die terugvoering!",
    "That didn't go to plan": "Dit het nie volgens plan verloop nie",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "Die epos addres wat ons vir u het is {memberEmail} — as dit nie korrek is nie, kan u dit opdateer in u <button>rekeninginstellings area</button>.",
    "There was a problem submitting your feedback. Please try again a little later.": "Daar was 'n probleem om u terugvoering in te dien. Probeer asseblief later weer.",
    "There was an error cancelling your subscription, please try again.": "",
    "There was an error continuing your subscription, please try again.": "",
    "There was an error processing your payment. Please try again.": "",
    "There was an error sending the email, please try again": "",
    "This gift can only be redeemed once and expires on {expiryDate}.": "",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This gift link is invalid.": "",
    "This site is invite-only, contact the owner for access.": "Hierdie webwerf is slegs op uitnodiging, kontak die eienaar vir toegang.",
    "This site is not accepting donations at the moment.": "",
    "This site is not accepting payments at the moment.": "",
    "This site only accepts paid members.": "",
    "Threads": "",
    "Tier": "",
    "To": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "Om die registrasie te voltooi, kliek op die bevestigingskakel in jou inboks. As dit nie binne 3 minute aankom nie, kontroleer asseblief jou spam-vouer!",
    "To continue to stay up to date, subscribe to {publication} below.": "",
    "Too many attempts try again in {number} days.": "",
    "Too many attempts try again in {number} hours.": "",
    "Too many attempts try again in {number} minutes.": "",
    "Too many different sign-in attempts, try again in {number} days": "",
    "Too many different sign-in attempts, try again in {number} hours": "",
    "Too many different sign-in attempts, try again in {number} minutes": "",
    "Too many sign-up attempts, try again later": "",
    "Try free for {amount} days, then {originalPrice}.": "Probeer gratis vir {amount} dae, dan {originalPrice}.",
    "Unable to initiate checkout session": "",
    "Unlock access to all newsletters by becoming a paid subscriber.": "Ontsluit toegang tot alle nuusbriewe deur 'n betaalde intekenaar te word.",
    "Unsubscribe from all emails": "Meld af van alle e-posse",
    "Unsubscribed": "Afgemeld",
    "Unsubscribed from all emails.": "",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "Deur van eposse af te skakel, sal nie u betaalde subskripsie van {title} kanselleer nie",
    "Update": "Opdateer",
    "Update your preferences": "Opdateer u voorkeure",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "Verifikasie skakel gestuur, kyk jou e-pos inkassie",
    "Verify your email address is correct": "Bevestig dat u e-posadres korrek is",
    "Verifying...": "",
    "View plans": "Kyk na planne",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "Ons kon u nie afskakel nie, omdat die e-pos adres nie gevind is nie. Kontak asseblief die webwerf eienaar.",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "We'll email it to the recipient on {deliveryDate}. A copy is in your inbox too.": "",
    "We'll email it to the recipient. A copy will be in your inbox too.": "",
    "Welcome back, {name}!": "Welkom terug, {name}!",
    "Welcome back!": "Welkom terug!",
    "Welcome to {siteTitle}": "Welkom by {siteTitle}",
    "What's included": "",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "As 'n inboks nie 'n e-pos aanvaar nie, word dit algemeen 'n 'bounce' genoem. In baie gevalle kan dit tydelik wees. In sommige gevalle kan 'n gebotsde e-pos egter as 'n permanente fout teruggekeer word wanneer 'n e-posadres ongeldig of nie-bestaande is nie.",
    "Why has my email been disabled?": "Waarom is my e-pos gedeaktiveer?",
    "X (Twitter)": "",
    "year": "",
    "Yearly": "Jaarliks",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "U het tans 'n gratis lidmaatskap, opgradeer na 'n betaalde intekening vir volle toegang.",
    "You have been successfully resubscribed": "U is suksesvol heringeskryf",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "U ontvang tans nie e-posse nie",
    "You're not receiving emails": "U ontvang nie e-posse nie",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "U ontvang nie e-posse nie, omdat u onlangs 'n boodskap as spam gemerk het, of omdat boodskappe nie na die e-pos adres wat u verskaf het gestuur kon word nie.",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership_other": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_one": "",
    "You've been gifted a <strong>{duration}-month</strong> {tierName} membership to {siteTitle}_other": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership": "",
    "You've been gifted a <strong>{duration}-year</strong> {tierName} membership to {siteTitle}": "",
    "You've been gifted a membership": "",
    "You've been gifted a membership to {siteTitle}": "",
    "You've successfully signed in.": "U het suksesvol aangemeld.",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "Jy het suksesvol ingeteken op <strong>{siteTitle}</strong>",
    "Your account": "U rekening",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "",
    "Your gift is on its way": "",
    "Your gift is ready": "",
    "Your gift is scheduled": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "",
    "Your input helps shape what gets published.": "U insette help om te bepaal wat gepubliseer word.",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "U intekening sal verval op {expiryDate}",
    "Your subscription will renew on {renewalDate}": "U intekening sal hernu op {renewalDate}",
    "Your subscription will start on {subscriptionStart}": "U intekening sal begin op {subscriptionStart}"
}
